<div *ngIf="isLoading" class="loading-container">
  <div class="spinner"></div>
  <p>Authenticating, please wait...</p>
</div>

<div *ngIf="connectionError && !isLoading" class="loading-container" role="alert">
  <p class="connection-error-message">{{ connectionErrorMessage }}</p>
  <button type="button" class="retry-btn" (click)="retryProfileBootstrap()">
    Retry
  </button>
</div>
